import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import { useNavigate } from 'react-router';
import { useAppDispatch } from '@/store/hooks';
import { enterDemoMode } from '@/store/authSlice';
import { seedDemoStore } from './seedDemoStore';

/**
 * Eager entry point for the deep-linkable `/demo` route. Dispatches
 * enterDemoMode(), seeds Redux from the bundled fixtures, then redirects to the
 * dashboard. Kept eager (not lazy) so the marketing deep-link enters demo with
 * no chunk-load flash. Renders a brief spinner during the one-tick handoff.
 */
export function DemoEntry() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const seeded = useRef(false);

  useEffect(() => {
    if (seeded.current) return;
    seeded.current = true;
    dispatch(enterDemoMode());
    seedDemoStore(dispatch);
    void navigate('/dashboard', { replace: true });
  }, [dispatch, navigate]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Spin size="large" />
      <p style={{ color: 'var(--color-text-secondary)', margin: 0 }}>{t('demo.loadingTreasury')}</p>
    </div>
  );
}

export default DemoEntry;
